import axios from 'axios';

async function get(url) {
  return axios({
    method: 'GET',
    url,
  })
    .then(response => response.data)
    .catch(error => {
      console.error(error);

      return [];
    });
}

export const fetchData = {
  get,
};
